import { CalendlyServiceCapabilities, SaveCalendlyLinkProps } from './calendlyService.types'

export const calendlyService = ({ percentClient }: CalendlyServiceCapabilities) => ({
  saveMeetingLink: (payload: SaveCalendlyLinkProps) => {
    return percentClient.post('/v1/store/calls', payload)
  }
})
